module.exports = __webpack_public_path__ + "img/85200.55bc9335.jpg";